import React from 'react';

function Seguridad() {
  return (
    <div style={{ maxWidth: '800px', margin: '0 auto', padding: '40px 24px', fontFamily: 'system-ui, sans-serif', color: '#1e293b', lineHeight: '1.7' }}>
      <h1 style={{ fontSize: '28px', fontWeight: '800', marginBottom: '8px' }}>Estándares de Seguridad</h1>
      <p style={{ color: '#64748b', marginBottom: '32px' }}>Última actualización: febrero de 2026</p>

      <h2 style={{ fontSize: '18px', fontWeight: '700', marginTop: '28px', marginBottom: '8px' }}>1. Transporte seguro</h2>
      <p>Todas las comunicaciones entre la aplicación y nuestros servidores se realizan mediante <strong>HTTPS/TLS</strong>, garantizando que los datos viajan cifrados en tránsito.</p>

      <h2 style={{ fontSize: '18px', fontWeight: '700', marginTop: '28px', marginBottom: '8px' }}>2. Autenticación</h2>
      <p>El acceso a la aplicación está protegido mediante <strong>tokens JWT</strong> con expiración. Las contraseñas se almacenan cifradas con <strong>bcrypt</strong> y nunca se guardan en texto plano.</p>

      <h2 style={{ fontSize: '18px', fontWeight: '700', marginTop: '28px', marginBottom: '8px' }}>3. Almacenamiento de datos</h2>
      <p>Los datos se almacenan en servidores ubicados en la <strong>Unión Europea</strong>. El acceso a la base de datos está restringido y protegido por credenciales seguras. No se almacenan datos de pago en nuestros sistemas.</p>

      <h2 style={{ fontSize: '18px', fontWeight: '700', marginTop: '28px', marginBottom: '8px' }}>4. Permisos de la aplicación</h2>
      <p>La aplicación solicita únicamente los permisos estrictamente necesarios:</p>
      <ul style={{ paddingLeft: '20px' }}>
        <li><strong>Notificaciones push</strong>: para avisar de novedades en la comunidad</li>
        <li><strong>Cámara / almacenamiento</strong>: para adjuntar imágenes a incidencias</li>
        <li><strong>Internet</strong>: para comunicarse con el servidor</li>
      </ul>
      <p>No se accede a contactos, ubicación, micrófono ni ningún otro sensor.</p>

      <h2 style={{ fontSize: '18px', fontWeight: '700', marginTop: '28px', marginBottom: '8px' }}>5. Datos compartidos con terceros</h2>
      <p>No se venden ni comparten datos personales con terceros con fines publicitarios. Se utilizan los siguientes servicios de terceros con fines operativos:</p>
      <ul style={{ paddingLeft: '20px' }}>
        <li><strong>Firebase (Google)</strong>: únicamente para el envío de notificaciones push</li>
      </ul>

      <h2 style={{ fontSize: '18px', fontWeight: '700', marginTop: '28px', marginBottom: '8px' }}>6. ID de publicidad</h2>
      <p>La aplicación <strong>no utiliza</strong> el ID de publicidad de Android (GAID) ni ningún otro identificador publicitario.</p>

      <h2 style={{ fontSize: '18px', fontWeight: '700', marginTop: '28px', marginBottom: '8px' }}>7. Actualizaciones y parches</h2>
      <p>Aplicamos actualizaciones de seguridad de forma regular. Se recomienda mantener la aplicación actualizada a su última versión disponible en Google Play.</p>

      <h2 style={{ fontSize: '18px', fontWeight: '700', marginTop: '28px', marginBottom: '8px' }}>8. Contacto</h2>
      <p>Para cualquier consulta relacionada con la seguridad de la aplicación, puedes ponerte en contacto con el administrador de tu comunidad a través de la propia aplicación.</p>

      <hr style={{ margin: '40px 0', border: 'none', borderTop: '1px solid #e2e8f0' }} />
      <p style={{ color: '#94a3b8', fontSize: '13px' }}>
        © 2026 HabitaPro. ·{' '}
        <a href="/privacidad" style={{ color: '#94a3b8' }}>Política de privacidad</a>
        {' · '}
        <a href="/eliminar-cuenta" style={{ color: '#94a3b8' }}>Eliminar cuenta</a>
      </p>
    </div>
  );
}

export default Seguridad;
